import { useInfiniteQuery } from '@ywwwtseng/react-kit';
import { Typography } from '@ywwwtseng/tma-react-kit';
import * as web3 from '@ywwwtseng/web3';
import { ArrowUp } from 'lucide-react';
import { List } from '../../components/common/List';
import * as utils from '../../utils';
import dayjs from '../../lib/dayjs';
import * as schema from '@/db/schema';

export default function GiftActivityScreen({
  params,
}: {
  params: { gift_id: string };
}) {
  const { data } = useInfiniteQuery<(typeof schema.logs.$inferSelect)[]>(
    'logs',
    {
      params: {
        limit: 20,
        type: `gift_claimed:${params.gift_id}`,
      },
      refetchOnMount: true,
    }
  );

  return (
    <div className="flex flex-col items-center justify-start w-full h-full gap-5 py-3 px-5">
      <List className="card flex flex-col w-full" data={data}>
        {({ id, created_at, user_first_name, amount, token_id }) => (
          <div
            key={id}
            className="h-stack w-full gap-2 px-1 py-1.5 cursor-pointer"
          >
            <ArrowUp className="w-6 h-6 min-w-6" />
            <div className="v-stack w-full !items-start">
              <div className="flex items-center gap-2">
                <Typography size="3" weight={500}>
                  {user_first_name}
                </Typography>
                <Typography size="3" weight={500} i18n="common.received" />
              </div>
              <Typography size="1" color="#777777">
                {dayjs(created_at).format('YYYY/MM/DD HH:mm')}
              </Typography>
            </div>
            <div className="v-stack w-full ml-auto !items-end">
              <Typography size="3" weight={500}>
                {`${web3.utils.formatUnits(
                  amount,
                  Number(token_id?.split(':')[1])
                )} ${utils.token.getTokenSymbol(token_id ?? '')}`}
              </Typography>
            </div>
          </div>
        )}
      </List>
    </div>
  );
}
